import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AppInformationService } from 'app/core/app-information.service';
import { BrewersUnitOfWork } from 'app/core/core.module';
import { HistoryService } from 'app/core/history.service';
import { SessionInformationService } from 'app/core/session-information.service';
import DataSource from 'devextreme/data/data_source';
import { RowDblClickEvent } from 'devextreme/ui/data_grid';
import { confirm } from 'devextreme/ui/dialog';

@Component({
    selector: 'app-invoice-history',
    standalone: false,
    templateUrl: './invoice-history.component.html',
    styleUrl: './invoice-history.component.scss',
})
export class InvoiceHistoryComponent {
    router = inject(Router);
    appInfo = inject(AppInformationService);
    historyService = inject(HistoryService);
    sessionInfo = inject(SessionInformationService);
    uow = inject(BrewersUnitOfWork);

    customersDS: DataSource;
    statuses: any[];
    ticketTypes: any[];

    filter: any;
    invoices: any[];

    async ngOnInit() {
        this.appInfo.pleaseWaitShow();
        const customers = await this.uow.customers.getLookupCustomers();
        this.customersDS = new DataSource({ store: customers, paginate: true });

        this.statuses = await this.uow.invoiceStatuses.whereActive('displayOrder, name');
        this.ticketTypes = await this.historyService.getTicketTypes();

        this.filter = this.sessionInfo.getItem('invoice-history-filter') ?? {};
        this.appInfo.pleaseWaitHide();
    }

    async search() {
        const hasSelectedFilter = this.hasSelectedFilter();
        if (!hasSelectedFilter) {
            const result = await confirm('No filters set. Are you sure you want to continue?', this.appInfo.settings.company);
            if (!result) return;
        }

        this.appInfo.pleaseWaitShow();
        this.invoices = await this.historyService.getInvoiceHistory(this.filter);
        this.sessionInfo.setItem('invoice-history-filter', this.filter);
        this.appInfo.pleaseWaitHide();
    }

    hasSelectedFilter() {
        return (
            this.filter &&
            (this.filter.customerId || this.filter.statusId || this.filter.ticketTypeId || this.filter.invoiceNumber || this.filter.invoiceDateStart || this.filter.invoiceDateEnd)
        );
    }

    clear() {
        this.filter = {};
        this.sessionInfo.removeItem('invoice-history-filter');
        this.invoices = null;
    }

    async rowDoubleClick(e: RowDblClickEvent) {
        if (!e.data?.id) return;
        await this.open(e.data);
    }

    async open(invoice: any) {
        if (!invoice) return;
        this.router.navigate([`/invoices/${invoice.id}`]);
    }
}
